module.exports = __webpack_public_path__ + "static/media/instagram.4bc7bf98.svg";